<template>
  <PricingBlock
    :agreement-label="$t('pages.entrance.personal_terms_of_service')"
    agreement-href="https://amaiz.com/files/Amaiz%20Personal%20Account%20Terms.pdf"
    pricing-href="https://amaiz.com/personal/pricing#details"
    :on-accept="onAccept"/>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';

import PricingBlock from '@/modules/onboarding/components/PricingBlock.vue';
import { usePersonalOnboardingStore } from '@/stores/OnboardingPersonal';
import { AnalyticsEvent, sendGAEvent } from '@/utils/sendGAEvent';

const router = useRouter();
const store = usePersonalOnboardingStore();

async function onAccept() {
  await store.personalOnboardingStoreActions.acceptPricing({
    onSuccess: async () => {
      sendGAEvent(AnalyticsEvent.PRICING_CONFIRM, {
        user_type: 'PERSONAL',
      });
      await router.push({ name: 'onboarding-personal-verification' });
    },
  });
}

onMounted(async () => {
  await store.fetchIndividualApplication();
});

</script>

<style lang="scss">
.pricing {
  @apply w-500;

  &-footer {
    @apply flex flex-col justify-center items-center mt-48 gap-24 mb-40;

    &-agreement {
      @apply w-310 text-center text-old-n-black-60 text-base font-normal;
    }
  }
}
</style>
